export class Area {
  areaId:string = '';
  name:string = '';
  active:boolean = false;
  lat:number = null;
  lon:number = null;
  taskConfig:any = {
    highThreshold: 80, //thing utilization to trigger task creation
    lowThreshold: 40, //lower utilization threshold for park closeout
    groupThreshold: 0, //minimum for group task creation
    groupThresholdCloseout: 0, // minimum for grouping at closeout
    maxThingsPerTask: 6, //max number of cans per task
    maxThingsPerTaskCloseout: 8, //max number of cans per task during closeout
    maxDistanceForThing: 50, //max distance from originating can
    maxDistanceForThingCloseout: 50, //max distance from originating can, currently same as maxDistanceForThing
    minutesToCreateNextTask: 50, //time to create next restroom task after it's cleaned
    minutesToAssignNextTask: 60, //time to assign next restroom task; should be >= minutesToCreateNextTask
    minutesToTaskNotAcceptedNotification: 5, //interval to send task not accepted notifications
    minutesToUnresponsiveSensor: 40, //notify for unresponsive sensor after not receiving readings for x
    sensorNotificationCheckRate: 10, //rate to check for and send unresponsive sensor notifications
    unresponsiveSensorCombineThreshold: 5, //combine to single notification if this many sensors are unresponsive
    minutesBetweenLowBatterySensor: 360, //recurring notification for low battery sensor
    lowBatteryThreshold: 10, //threshold to notify for low battery sensors
    closeoutReminderMinutes: 75, //time before park closing time for courtesy closeout reminder notification
    separateTrashAndRecycle: false, //Boolean to determine if trash and recycle should not be grouped. True they'll be separate, false they're together.
  };
  bounds:bounds = {
    lat1: null,
    lon1: null,
    lat2: null,
    lon2: null
  };
  openBy: string;
  modifyDateTime: string;
  openDateTime: string;
  openTaskAssignmentDateTime: string;
  sensorNotificationCheckDateTime: string;
  imageSrc: string;
  timezone: string;
  openingTime: string;
  closingTime: string;
  enableTaskCompletion: boolean;

  constructor() {}
}

export interface bounds {
  lat1:number;
  lon1:number;
  lat2:number;
  lon2:number;
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/area.ts